import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["branchSelect", "serviceSelect", "serviceSelectWrapper"]
  static values = { url: String }

  branchChanged() {
    const branchId = this.branchSelectTarget.value
    if (!branchId) {
      this.serviceSelectWrapperTarget.classList.add("hidden")
      return
    }

    fetch(`${this.urlValue}?source_branch_id=${branchId}`, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(services => {
        this.serviceSelectTarget.innerHTML = `<option value="">${this.serviceSelectTarget.dataset.placeholder}</option>`
        services.forEach(service => {
          const option = document.createElement("option")
          option.value = JSON.stringify(service)
          option.textContent = service.name
          this.serviceSelectTarget.appendChild(option)
        })
        this.serviceSelectWrapperTarget.classList.remove("hidden")
      })
  }

  serviceChanged() {
    const value = this.serviceSelectTarget.value
    if (!value) return

    const service = JSON.parse(value)
    const form = this.element.closest(".container").querySelector("form")

    this._setField(form, "service[name]", service.name)
    this._setField(form, "service[duration]", service.duration)
    this._setField(form, "service[break_time]", service.break_time)
    this._setField(form, "service[price]", service.price)
    this._setField(form, "service[deposit_amount]", service.deposit_amount || "")
    this._setField(form, "service[maximum_users_per_slot]", service.maximum_users_per_slot)

    // Set service group name in the combobox input and clear the hidden ID
    const groupInput = form.querySelector("[data-combobox-target='input']")
    if (groupInput) {
      groupInput.value = service.service_group_name || ""
    }
    const groupHiddenId = form.querySelector("[data-combobox-target='hiddenId']")
    if (groupHiddenId) {
      groupHiddenId.value = ""
    }
  }

  _setField(form, name, value) {
    const field = form.querySelector(`[name="${name}"]`)
    if (field) field.value = value
  }
}
